import {Component, EventEmitter, Inject, Input, OnInit, Output} from '@angular/core';
import {environment} from "@environment";
import {AbstractComponent} from "../abstract.component";
import {CompetitorResultsService, LoaderService} from "@services";
import {
  CategoryItem,
  CompetitorFilter,
  CompetitorResults, DEFAULT_PAGE_INDEX,
  DEFAULT_PAGE_SIZE,
  EventItem,
  Lookups, PagedFilter, Pages, Paging, Race,
  Request
} from "@model";
import {DOCUMENT} from "@angular/common";

@Component({
  selector: 'app-results-table',
  templateUrl: './results-table.component.html',
  styleUrls: ['./results-table.component.scss']
})
export class ResultsTableComponent extends AbstractComponent implements OnInit, Paging<CompetitorResults> {
  @Input() currentEventItem: EventItem | undefined;
  @Input() race: Race | undefined;
  @Input() filteringEnabled: boolean = true;
  @Input() showEmptyState: boolean = true;
  @Input() showBorderBottom: boolean = true;
  @Input() results: CompetitorResults[] = [];
  @Input() categories: CategoryItem[] = [];
  @Input({required: true}) languages: Lookups[] = [];
  @Input() genders: Lookups[] = [];
  @Input() isAdmin: boolean = false;
  @Input() showRaceNameInTable: boolean = false;
  @Input() showDateOfBirthInTable: boolean = false;
  @Output() filterChange: EventEmitter<PagedFilter<CompetitorFilter>> = new EventEmitter<PagedFilter<CompetitorFilter>>();

  environment: any = environment;
  name: string = "";
  category: number | undefined = undefined;
  hasMore: boolean = false;
  showFabButton: boolean = false;
  page: number = DEFAULT_PAGE_INDEX;
  isLoading: boolean = false;
  gender: number | undefined = undefined;
  filter: PagedFilter<CompetitorFilter> | undefined;

  constructor(@Inject(DOCUMENT) private document: Document, private loaderService: LoaderService,
              private competitorResultsService: CompetitorResultsService) {
    super();
  }

  ngOnInit(): void {
    this.handleExploreResult(this.results);
  }

  handleSearchInput(value: string): void {
    this.name = value;
    this.onExplore(false);
  }

  handleGenderSelection(value?: any): void {
    if (value === this.gender || !value) {
      this.gender = undefined;
    } else {
      this.gender = value;
    }
    this.onExplore(false);
  }

  handleCategorySelection(value?: any): void {
    if (value === this.category || !value) {
      this.category = undefined;
    } else {
      this.category = value;
    }
    this.onExplore(false);
  }

  scrollToTop(): void {
    return this.document.body.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
      inline: 'start'
    });
  }

  private getFilter(): CompetitorFilter {
    let filter: CompetitorFilter = new CompetitorFilter();
    if (this.category) {
      filter.categories = [this.category];
    }
    filter.gender = this.gender ?? undefined;
    filter.name = this.name;
    filter.eventId = this.currentEventItem?.id;
    filter.raceId = this.race?.id;
    return filter;
  }

  handleExploreResult(value: CompetitorResults[], loadMore?: boolean): void {
    if (value) {
      if (value.length > DEFAULT_PAGE_SIZE) {
        value = (value.slice(0, DEFAULT_PAGE_SIZE))
        this.hasMore = true;
      } else {
        this.hasMore = false;
      }
      if (loadMore && this.results) {
        value = this.results.concat(value)
      }
    }
    this.setListOfItems(value);
  }

  setListOfItems(value: Request[] | null) {
    if (value && value.length > 0) {
      this.results = value;
      this.page++;
    } else {
      this.results = [];
    }
  }

  onExplore(loadMore?: boolean) {
    if (loadMore === true) {
      this.loaderService.startLoading();
    } else {
      this.page = 1;
      this.isLoading = true;
    }
    this.filter  = new PagedFilter(new Pages(undefined, this.page), this.getFilter());
    this.competitorResultsService.getCompetitorResults(this.filter).subscribe((value: CompetitorResults[]) => {
      if (loadMore === true) {
        this.loaderService.dismissLoading();
      } else {
        setTimeout(() => {
          this.isLoading = false;
        }, 300);
      }
      this.handleExploreResult(value, loadMore);
    });
    this.emitFilter();
  }

  emitFilter(): void {
    this.filterChange.emit(this.filter);
  }

  loadMore() : void {
    this.onExplore(true);
  }

  protected readonly Array: ArrayConstructor = Array;
}
